import React from "react";
import PaymentBACSPage from "./PaymentBACSPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface PaymentBACSPageContainerProps extends RouteProps, withValidUserRoleProps {}

const PaymentBACSPageContainer = (props: PaymentBACSPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <PaymentBACSPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(PaymentBACSPageContainer);
